function state() {
    return {
        microwaveProducts: [],
        thermosesProducts: [],
        teaProducts: [],
    };
}

const mutations = {
    SET_MICROWAVE_PRODUCTS(state, { products }) {
        state.microwaveProducts = products;
    },
    SET_THERMOSES_PRODUCTS(state, { products }) {
        state.thermosesProducts = products;
    },
    SET_TEA_PRODUCTS(state, { products }) {
        state.teaProducts = products;
    },
};

const actions = {
    getCatalogProducts({ commit }, { categoryId, type }) {
        return this.productsApi
            .getCatalogByCategory({
                listCategories: `categoriesIds[]=${categoryId}`,
                limit: 30,
            })
            .then((response) => {
                commit(mutationsList[type], response);
            });
    },
};

const mutationsList = {
    thermoses: "SET_THERMOSES_PRODUCTS",
    tea: "SET_TEA_PRODUCTS",
    microwave: "SET_MICROWAVE_PRODUCTS",
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
